import type { PageGroupItemViewModel } from '@trinnvis/dabih-api-client';

export function getPage(pageId: number, pages: PageGroupItemViewModel[]): PageGroupItemViewModel | undefined {
  return pages.find((page) => {
    return page.pageId === pageId;
  });
}
